export default __webpack_public_path__ + "static/red_frog_desktop-ef50718aba05b9cd15763fc0fd4ebf66.png";